import { ChangeDetectorRef, Component, ElementRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-petl-start-ng',
    styleUrls: ['../../sharedStyles/base.scss', '../petl-base.scss', './start.component.scss'],
    templateUrl: './start.component.html'
})

export class PetlStartComponent extends PetlBaseComponent {

    @ViewChild('fileSelectedButton') fileSelectedButton: ElementRef<HTMLElement>;

    isfileDraggedOver: boolean = false;

    constructor(_vcr: ViewContainerRef, protected readonly petlService: PetlService, protected readonly cdr: ChangeDetectorRef) {
        super(_vcr, petlService, cdr);
    }

    get startNumber() {
        return this.petlService.startingRowNumber;
    }
    set startNumber(newValue) {
        this.petlService.startingRowNumber = newValue;
    }

    async fileSelected() {
        const file = (<any>this.fileSelectedButton.nativeElement).files[0];
        await this.petlService.sendFile(file);
    }

    browseToUploadFile() {
        this.fileSelectedButton.nativeElement.click();
        return false;
    }

    dragEnter(ev: DragEvent) {
        ev.preventDefault();
        this.isfileDraggedOver = true;
    }

    dragOver(ev: DragEvent) {
        ev.preventDefault();
        this.isfileDraggedOver = true;
    }

    dragLeave(ev: DragEvent) {
        ev.preventDefault();
        this.isfileDraggedOver = false;
    }

    drop(ev: DragEvent) {
        this.service.processFileDrop(ev);
        this.isfileDraggedOver = false;
    }

}
